import {DotLottieReact} from '@lottiefiles/dotlottie-react'

import spinnerLottie from '@/assets/lotties/spinner.lottie'
import {useIsMobile} from '@/utils/hooks/useWindowSize'
import style from '@/views/Stores/StoreFront.module.scss'

interface StoreHeroProps {
  title: string
  bannerSrc?: string
  bannerMobileSrc?: string
}

export default function StoreHero({title, bannerSrc, bannerMobileSrc}: StoreHeroProps) {
  const isMobile = useIsMobile(767)
  const [isLoading, setIsLoading] = useState(true)

  const currentBanner = isMobile ? bannerMobileSrc : bannerSrc

  return (
    <div className={style.Hero}>
      <img
        src={currentBanner}
        alt={`${title} banner`}
        onLoad={() => {
          setIsLoading(false)
        }}
        onError={() => {
          setIsLoading(false)
        }}
        aria-hidden={isLoading}
      />
      {isLoading && (
        <div className={style.SpinnerContainer}>
          <DotLottieReact
            src={spinnerLottie}
            autoplay
            loop
            className={style.Spinner}
            aria-label='Loading banner...'
            role='progressbar'
          />
        </div>
      )}
    </div>
  )
}
